<template>
  <div class="kw_image_canvas">
    <el-dialog :visible.sync="imageCanvasInfo.ifLoad" top="5vh" width="100%" title="海报" :append-to-body="true">
      <div style="text-align: center">
        <img :style="'width:'+(imgPositionInfo.canvasWidth)+'px; height:'+(imgPositionInfo.canvasHeight)+'px;'"  :src="hbImgSrc" />
      </div>
      <button @click="saveImgToPhoto" class="saveToAlbum">保存到相册</button>
    </el-dialog>
  </div>
</template>

<script>

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_image_canvas',
  props: {
    imageCanvasInfo:{

    },
    dataInfo: {
      type: Object,
      value: null
    },
    buttonSet: {
      type: Object,
      value: null
    }
  },
  data() {
    return {
      //ios全面屏特殊处理
      // isIphoneX: app.globalData.isIphoneX,
      // 背景图片
      // 需要生成的二维码地址 或者二维码图片
      bgImgUrl:null,
      codeImgUrl:null,
      // 
      imgPositionInfo:{
        // 底图的宽度
        //canvasWidth: wx.getSystemInfoSync().windowWidth,//375 //自适应
        canvasWidth: ((window.screen.width / 375) < (window.screen.height / 667)) ? window.screen.width : ((window.screen.height * 375) / 667),
        // 底图的高度
        //canvasHeight: wx.getSystemInfoSync().windowHeight,//667 //自适应
        canvasHeight: ((window.screen.width / 375) >= (window.screen.height / 667)) ? window.screen.height : ((window.screen.width * 667) / 375),
        // 二维码宽度
        codeWidth:100,
        // 二维码高度
        codeHeigth: 100,
        // 二维码位置x
        codeX: 275,
        // 二维码位置y
        codeY: 479,
      },
      // 展示遮罩层
      show: false,
      // 生成的海报图片的地址
      hbImgSrc:'',
      // 计算头部高度
      // someData: {
      //   statusBarHeight: window..statusBarHeight,
      //   titleBarHeight: app.globalData.titleBarHeight
      // }
    };
  },
  created() {
    this.initAttached();
  },
  mounted() {
    
  },
  watch:{
    dataInfo:function(){
      this.initInfo();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    onClickHide:function(){
      this.show = false;
      this.$emit("onClose");
    },
    initInfo: function () {
      this.initAttached();
    },
    initAttached: function () {
      var that = this;
      var fileServeUrl = this.GLOBAL.getFileServeUrl();
      var dataInfo = this.dataInfo;
      console.log("dataInfo=================================", dataInfo);
      var shareFile = dataInfo.SHARE_FILE;
      if (shareFile) {
        shareFile = fileServeUrl + shareFile;
        var shareKeyName = "bgImgUrl";
        this.getBjFile(shareFile, shareKeyName);
        var pages = "";
        var scene = "";
        // 是否转发首页 如果设置转发首页时  转发首页页面
        if (dataInfo.SHARE_HOME == 1) {
          pages = "pages/newMail/mail_home";
          var userId = localStorage.USERID;
          // 记录二维码的学员是谁
          scene = "S:" + userId;
        } else {
          // 获取当前页面的路径 进行海报二维码生成
          var pageRouteInfo = pageUtils.getShareRouteInfo(that,1);
          pages = pageRouteInfo.pageRoute;
          scene = pageRouteInfo.scene
          // 暂时先随便放一个  发布正式时去除！！！
          pages = "pages/pageShow/look/look";
        }
        // 获取当前页面的路径
        this.getCodeFile(pages, scene);
        this.show = true;
      } else {
        console.log("海报还没准备好,先分享给朋友吧================");
        this.$message("海报还没准备好,先分享给朋友吧");
      }
    },
    /**
     * 获取二维码图片
     */
    getCodeFile: function (pages, scene){
      var that = this;
      var url = "qrCode_getXcxCode.do";
      // pages/pageShow/look/look
      // pages/newMail/mail_home 
      var toHtData = {
        pages: pages,
        fileName:"share",
        sceneStr: scene
      };
      var saveLoading = that.$loading({
        lock: true,
        text: '生成二维码中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      utils.request(that,{
        url: url, //仅为示例，并非真实的接口地址
        data: toHtData,
        success: function (res) {
          saveLoading.close();
          var codeFile = res.data;
          codeFile = that.GLOBAL.baseURL + codeFile;
          var shareKeyName = "codeImgUrl";
          that.getBjFile(codeFile, shareKeyName);
        },
        noLoginFun:function(res){
          saveLoading.close();
        }
      })
    },
    /**
     * 获取背景图片
     */
    getBjFile:function(fileUrl,keyName){
      var that = this;
      if (keyName == "bgImgUrl") {
        that.bgImgUrl = fileUrl;
      } else if (keyName == "codeImgUrl"){
        that.codeImgUrl = fileUrl;
      }
      that.createPhoto();
    },
    // 保存图片到相册
    createPhoto: function () {
      var that = this;
      var bgImgUrl = this.bgImgUrl;
      var codeImgUrl = this.codeImgUrl;
      console.log("bgImgUrl============", bgImgUrl);
      console.log("codeImgUrl============", codeImgUrl);
      if (!codeImgUrl || !bgImgUrl) {
        return;
      }
      console.log("open draw: ", bgImgUrl, codeImgUrl)
      var imgPositionInfo = this.imgPositionInfo;
      // 背景图片的宽
      let imgW = imgPositionInfo.canvasWidth   //res.width  //自适应
      // 背景图片的高
      let imgH = imgPositionInfo.canvasHeight

      var codeRightPx = 30;
      var codeButtonPx = 10;
      var dataInfo = that.dataInfo;
      if (dataInfo) {
        if (dataInfo.CODE_RIGHT_PX > 0) {
          codeRightPx = dataInfo.CODE_RIGHT_PX;
        }
        if (dataInfo.CODE_BUTTON_PX > 0) {
          codeButtonPx = dataInfo.CODE_BUTTON_PX;
        }
      }
      // 绘制二维码
      var codeX = imgPositionInfo.canvasWidth - imgPositionInfo.codeWidth - codeRightPx;
      var codeY = imgPositionInfo.canvasHeight - imgPositionInfo.codeHeigth - codeButtonPx;
      var codeWidth = imgPositionInfo.codeWidth;
      var codeHeigth = imgPositionInfo.codeHeigth;
      console.log('二维码codeX:', codeX, '二维码codeY:', codeY)
      var saveLoading = that.$loading({
        lock: true,
        text: '生成海报中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var toHtData = {};
      toHtData.backgroundPath = bgImgUrl;
      toHtData.qrCodePath = codeImgUrl;
      toHtData.backgroundWidth = imgW.toFixed(0);
      toHtData.backgroundHeight = imgH.toFixed(0);
      toHtData.codeLeft = codeX.toFixed(0);
      toHtData.codeTop = codeY.toFixed(0);
      toHtData.codeWidth = codeWidth.toFixed(0);
      toHtData.codeHeight = codeHeigth.toFixed(0);
      utils.request(that,{
            url: 'qrCode_getHbImg.do', //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
              saveLoading.close();
              var hbImgSrc = res.data;
              that.hbImgSrc = that.GLOBAL.baseURL+hbImgSrc;
            }
        })
     

    },
    saveImgToPhoto(){
      var that = this;
      if(this.hbImgSrc){
        var triggerEvent = "touchstart";
        that.savePicture(this.hbImgSrc);

        // window.open(this.hbImgSrc);
        // 保存成功 判断后续操作设置 
        that.saveImageAfter();
        // 关闭海报页面
        that.onClickHide();
      }else{
        console.log("海报不存在，请重新生成！")
      }
    },
    savePicture(Url){
        var blob=new Blob([''], {type:'application/octet-stream'});
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = Url;
        a.download = Url.replace(/(.*\/)*([^.]+.*)/ig,"$2").split("?")[0];
        var e = document.createEvent('MouseEvents');
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
        URL.revokeObjectURL(url);
        this.$message({
          message: '根据浏览器提示进行下载,或者长按图片进行下载!',
          type: 'success'
        });
    },
    /**
     * 保存图片后执行的方法
     */
    saveImageAfter(){
      var that = this;
      var dataInfo = that.dataInfo;
      var buttonSet = that.buttonSet;
      console.log("buttonSet======================", buttonSet);
      if (buttonSet && buttonSet.styleSet) {
        // 记录操作历史
        if (buttonSet.styleSet.nextOperaType == 7) {
          var toHtData = {};
          toHtData.isInterFace = 1;
          toHtData.tableId = buttonSet.styleSet.clickTableId;
          toHtData.pageId = buttonSet.styleSet.clickPageId;
          toHtData.DATA_ID = dataInfo.LMF_ID;
          var pageRouteInfo = pageUtils.getShareRouteInfo(that,1);
          toHtData.PAGE_ROUTE = pageRouteInfo.pageRoute;
          toHtData.TABLE_ID = pageRouteInfo.tableId;
          toHtData.PAGE_ID = pageRouteInfo.pageId;
          toHtData.LOOK_DATA_ID = pageRouteInfo.mainId;

          var url = "add_addInfo.do";
          //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
          utils.request(that,{
            url: url, //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
              // 分享成功 积分增加
              if(res.data > 0) {
                that.$message({
                  message: '分享成功,积分已增加',
                  type: 'success'
                });
              } else {
                that.$message({
                  message: '已分享过,今天积分已增加',
                  type: 'success'
                });
              }
              that.reload();
            }
          })

        }
      }
    },
    success(src) {
      // 设置img的src
      this.poster = src
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .saveToAlbum{background: #3BAE56;
    color: #ffffff;
    width: 100%;
    z-index: 9999;
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    border:none;
    position: fixed;
    bottom: 0;
  }
</style>
<style>
  .el-dialog__body{padding: 0 !important;}
  /*.el-dialog{margin: 5vh auto 0 !important;}*/
</style>
